import { Link,useNavigate,useLocation } from "react-router-dom";
import "./nav_login_signup_login.css"
import { useEffect, useState } from "react";
//import "../../pages/app-wide.css";

const NavbarSignUpLogin = ({hideNav=false, isSignup=false, isLogin=false}) => {

  const [isSignUp, setIsSignUp] = useState(false)

  const location = useLocation();

  useEffect(()=>{
    if(location.pathname =="/signup"){
        setIsSignUp(true)
    }else{
        setIsSignUp(false)
    }
  });
  

  return (
    <nav className="logn-signup-nav-section-home">
      {/*logo*/}

        <div className="login-signup-nav-section-login-container">
            <div className="login-signup-nav-container">
                <div className={isSignUp?"login-signup-nav-section-home-login-outer":"login-signup-nav-section-home-login-outer-left-none"}>
                        <Link to="/signup" className={null}><button className={"login-signup-nav-section-home-login-inner-left"}>Sign Up</button></Link>
                </div>
            </div>
            <div className="login-signup-nav-container">
                <div className={isSignUp?"login-signup-nav-section-home-login-outer-left-none":"login-signup-nav-section-home-login-outer"}>
                    <Link to="/login" className={null}><button className={"login-signup-nav-section-home-login-inner-right"}>Login</button></Link>
                </div>
            </div>
        </div>
    </nav>
  );
};

export default NavbarSignUpLogin;